import React, { Component } from "react";
import { Redirect, withRouter } from "react-router-dom";
import axios from "axios";

import {
  Button,
  Alert,
  Form,
  Col,
  FormGroup,
  Label,
  Input,
  Container,
  Card,
  CardBody
} from "reactstrap";

class NewPassword extends Component {
  static displayName = "Forgot Password Page";

  constructor(props) {
    super(props);

    this.state = {
      password: "",
      error: "",
      success: false,
      message: ""
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(name, value) {
    this.setState({ [name]: value });
  }

  handleSubmit(e) {
    e.preventDefault();
    const { password } = this.state;
    const token = this.props.match.params.token;
    let self = this;
    axios
      .post("/auth/reset-password/new/" + token, { password: password })
      .then(res => {
        self.setState({
          success: true,
          error: "",
          message: res.message
        });
      })
      .catch(function(error) {
        alert(error.response.data.message);
        console.log(error);
      });
  }

  render() {
    if (this.props.isAuthenticated) {
      return <Redirect to="/" />;
    }

    return (
      <section className="login-container">
        <Container>
          <Col sm={10} md={6} lg={4} xl={4}>
            <Card>
              {/* <CardBody><img src={Logo} width={180} /></CardBody> */}
              <CardBody>
                {!this.state.success ? (
                  <Form onSubmit={this.handleSubmit}>
                    <FormGroup>
                      <Label htmlFor="password">Set your new password</Label>
                      <Input
                        placeholder="New Password"
                        type="password"
                        name="password"
                        autoFocus
                        onChange={e =>
                          this.handleChange(e.target.name, e.target.value)
                        }
                      />
                    </FormGroup>

                    <FormGroup>
                      <Button color="primary" type="submit" size="lg" block>
                        Reset Password
                      </Button>
                    </FormGroup>
                    {this.state.error ? (
                      <FormGroup>
                        <Alert color="danger">{this.state.error}</Alert>
                      </FormGroup>
                    ) : (
                      ""
                    )}
                  </Form>
                ) : (
                  <div>
                    Your password has been changed<br />{" "}
                    <a href="/login">Login using your new password</a>{" "}
                  </div>
                )}
              </CardBody>
            </Card>
          </Col>
        </Container>
      </section>
    );
  }
}

export default withRouter(NewPassword);



// WEBPACK FOOTER //
// ./src/system/containers/ForgotPassword/NewPassword.jsx